<template>
  <div class="action-page" :style="{ 'z-index': zindex }">
    <setting-vue></setting-vue>
    <el-button round class="btn-mic" @click.stop="openDressupDialog()"
      >裝扮</el-button
    >
    <asking-mic-queue v-if="isHost || isCreate || isAdmin"></asking-mic-queue>
    <el-button
      round
      class="btn-mic"
      @click="switchApplyMic()"
      v-if="!isOnSeat && !isCreate && !isAdmin"
      :loading="applyMicLoading"
    >
      <i class="icon-voice"> <img src="../images/apply-mic.png" alt="" /> </i
      >{{ isApplyMic ? '取消申请' : '上麥申請' }}</el-button
    >
    <el-button round class="btn-mic" @click="leaveSeat()" v-if="isOnSeat"
      >下麥</el-button
    >
    <img
      class="mic-on"
      src="../images/voice_room_mic_off.webp"
      alt=""
      @click="openMic()"
      v-if="isOnSeat && !isOpenMic"
    />
    <img
      class="mic-on"
      src="../images/voice_room_mic_on.webp"
      alt=""
      @click="closeMic()"
      v-if="isOnSeat && isOpenMic"
    />
    <img
      class="icon-gift"
      src="../images/voice_room_gift.png"
      alt=""
      @click.stop="sendGift(sendGiftUserList)"
    />
    <img
      class="hitbox-icon"
      src="../images/hitbox-icon-box.png"
      alt=""
      @click.stop="openHitBoxDialog()"
    />
    <template v-if="activityList && activityList.length">
      <div class="activity-box">
        <div v-for="(item, index) of activityList" :key="index">
          <img
            class="activity-icon"
            :src="item.imgUrl"
            alt=""
            @click.stop="openActivity(item.h5Url)"
            v-if="item.imgUrl"
          />
        </div>
      </div>
    </template>

    <gift-vue ref="gift" @open-diamond-box="openHitBoxDialog()"></gift-vue>
    <critical-hit-box ref="hitBox"></critical-hit-box>
    <dressup-vue
      ref="dressup"
      :roomId="roomId"
      @close-dialog="zindex = 2"
    ></dressup-vue>
  </div>
</template>
<script>
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import SeatProvider from '@/components/VoiceRoom/seatProvider';
import mRtc from '@/components/VoiceRoom/mRtc';
import GiftVue from './gift.vue';
import DressupVue from './dressup.vue';
import CriticalHitBox from './critical-hit-box.vue';
import AskingMicQueue from './asking-mic-queue.vue';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';
import SettingVue from './setting.vue';
export default {
  name: 'ActionPage',
  components: {
    GiftVue,
    AskingMicQueue,
    CriticalHitBox,
    DressupVue,
    SettingVue
  },
  data() {
    return {
      leaveSeatLoading: false,
      userList: [],
      zindex: 2,
      activityList: []
    };
  },
  watch: {
    isOnSeat: {
      handler: function(nval) {
        if (nval) {
          SeatProvider.isApplyMic = false;
        }
      },
      immediate: true
    },
    seatList: {
      handler: function(nval) {
        const list = [];
        nval.forEach(seatItem => {
          const seatUserId =
            seatItem && seatItem.userUuid ? seatItem.userUuid : null;
          if (seatUserId && seatUserId != this.uuid) {
            const user = this.userList.find(item => {
              return seatUserId === item.userUuid;
            });
            if (user) {
              list.push(user);
            } else {
              list.push({
                user: seatItem,
                isSelect: false
              });
            }
          }
        });
        this.userList = list;
      },
      deep: true,
      immediate: true
    }
    // seatMic: {
    //   handler: function(nval, oval) {
    //     if (nval != oval) {
    //       if (nval) {
    //         this.openMic();
    //       } else {
    //         this.closeMic();
    //       }
    //     }
    //   }
    // }
  },
  computed: {
    isTest() {
      return this.roomId === '202312143762573';
      // const list = [
      //   '157263',
      //   '3861785',
      //   '145108',
      //   '3308625',
      //   '4285891',
      //   '2266452',
      //   '4292676'
      // ];
      // return list.includes(this.uuid)
    },
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    },
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    // 當前用戶是否在麦位上
    isOnSeat() {
      return CurrentUserProvider.isOnSeat;
    },
    // 是否主持人
    isHost() {
      return SeatProvider.isHost;
    },
    // 是否房主
    isCreate() {
      return CurrentUserProvider.isCreate;
    },
    // 是否管理员
    isAdmin() {
      return CurrentUserProvider.isAdmin;
    },
    // 是否申请麦位
    isApplyMic() {
      return SeatProvider.isApplyMic;
    },
    // 是否申请麦位
    applyMicLoading() {
      return SeatProvider.applyMicLoading;
    },
    // 是否已开麦
    isOpenMic() {
      return mRtc.isOpenMic;
    },
    // 麦位上的麦克风设置是否打开或关闭
    seatMic() {
      try {
        return CurrentUserProvider.seatInfo.mic;
      } catch (error) {
        return 0;
      }
    },
    // 麦位
    seatList() {
      return SeatProvider.list;
    },
    sendGiftUserList() {
      const list = [];
      this.seatList.forEach(seatItem => {
        const seatUserId = seatItem ? seatItem.userUuid : null;
        if (seatUserId && seatUserId != this.uuid) {
          list.push({
            user: seatItem,
            isSelect: false
          });
        }
      });
      return list;
    }
  },
  methods: {
    async leaveSeat() {
      if (this.leaveSeatLoading) {
        return;
      }
      this.leaveSeatLoading = true;
      await SeatProvider.leaveSeat();
      await mRtc.leaveSeat();
      this.leaveSeatLoading = false;
    },
    async openMic() {
      if (!this.isOnSeat) {
        return;
      }
      try {
        // await switchMic({ roomUid: this.roomId, mic: 1 });
        await mRtc.openMic();
      } catch (error) {
        console.log(error);
      }
    },
    async closeMic() {
      // await switchMic({ roomUid: this.roomId, mic: 0 });
      await mRtc.closeMic();
    },
    //申请上麦/取消申请
    async switchApplyMic() {
      if (this.isApplyMic) {
        await this.cancelApplyMic();
      } else {
        await this.applyMic();
      }
    },
    async applyMic() {
      await SeatProvider.applyMic();
    },
    async cancelApplyMic() {
      await SeatProvider.cancelApplyMic();
    },
    sendGift(userList, toTargetUser) {
      this.$refs.gift.init(userList, toTargetUser);
    },
    openHitBoxDialog() {
      this.$refs.hitBox.show();
    },
    openDressupDialog() {
      this.zindex = 1;
      this.$refs.dressup.init();
    },
    async getActivityList() {
      const { data } = await this.$http.get('/activity/infoList');
      this.activityList = data;
    },
    openActivity(url) {
      window.open(url, '_blank');
    }
  },
  created() {
    this.getActivityList();
    VoiceRoomEventEmitter.on(VoiceRoomEvent.initCurrentUserSeat, () => {
      if (this.isOnSeat) {
        this.leaveSeat();
      }
    });
    VoiceRoomEventEmitter.on(VoiceRoomEvent.onMicChange, message => {
      const { userUuid } = message;
      if (userUuid === this.uuid) {
        if (this.mic === 1) {
          this.openMic();
        }
        if (this.mic === 0) {
          this.closeMic();
        }
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.action-page {
  padding: 0 20px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  img {
    width: 36px;
  }
  .btn-mic {
    // background-color: #981f57;
    color: white;
    font-size: 14px;
    border-radius: 36px;
    // border-radius: 42px;
    padding: 0 15px;
    // padding: 0 33px 0 28px;
    border: none;
    margin-right: 10px;
    background: rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;

    /deep/ span {
      display: flex;
      align-items: center;
      height: 44px;
    }
    .icon-voice {
      display: inline-block;
      img {
        width: 19px;
        height: 19px;
        margin-right: 7px;
      }
    }
  }
  .icon-gift {
    width: auto;
    height: 42px;
    margin-left: 10px;
  }
  .mic-on {
    width: auto;
    height: 42px;
  }
  .hitbox-icon {
    position: absolute;
    bottom: 118px;
    width: 96px;
    right: 0;
  }
  .activity-box {
    position: absolute;
    bottom: 200px;
    right: 16px;
    display: flex;
    flex-direction: column;
  }
  .activity-icon {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 50%;
    cursor: pointer;
    margin-bottom: 10px;
  }
}
</style>
